/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FinancialSupportCaseResultDto } from '../../models/financial-support-case-result-dto';

export interface FinancialSupportCaseControllerFindResult$Params {
  id: string;

/**
 * 분석 케이스 생성 시 발급한 비회원 세션 토큰
 */
  'X-Financial-Support-Token': string;
}

export function financialSupportCaseControllerFindResult(http: HttpClient, rootUrl: string, params: FinancialSupportCaseControllerFindResult$Params, context?: HttpContext): Observable<StrictHttpResponse<FinancialSupportCaseResultDto>> {
  const rb = new RequestBuilder(rootUrl, financialSupportCaseControllerFindResult.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Financial-Support-Token', params['X-Financial-Support-Token'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FinancialSupportCaseResultDto>;
    })
  );
}

financialSupportCaseControllerFindResult.PATH = '/api/financial-support/cases/{id}';
